import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useHoldOrderActionsViewModel = () => {
  const stateManager = useComponentState();

  const holdOrder = (orderId, data) => {
    return stateManager.run(async () => {
      const response = await taskService.order.hold({
        orderId,
        data,
        toastMessageConfig: {
          success: { text: "Follow-up logged successfully." },
        },
      });

      return response.status === HTTP_STATUSES.OK;
    });
  };

  return { isLoading: stateManager.isBusy(), holdOrder };
};
